import styled from "styled-components";
import { Typography } from "antd";

const { Paragraph, Title } = Typography;

export const StyledTitle = styled(Title)`
  margin-top: 0;
  padding-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledText = styled.p`
  color: #808080;
`;

export const StyledParagraph = styled(Paragraph)`
  color: #808080;
`;
